(function(){
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.getElementById('siteHeader');
  var progressBar = document.getElementById('scrollProgress');

  function updateProgress(){
    var h = document.documentElement;
    var scrollable = h.scrollHeight - h.clientHeight;
    var pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
    if (progressBar) progressBar.style.width = pct + '%';
  }

  if (header) {
    window.addEventListener('scroll', function(){
      header.classList.toggle('scrolled', window.scrollY > 40);
      updateProgress();
    }, { passive:true });
  }
  updateProgress();

  var burger = document.getElementById('burgerBtn');
  var panel = document.getElementById('mobilePanel');
  function closeMobile(){
    if (burger) burger.classList.remove('open');
    if (panel) panel.classList.remove('open');
  }
  if (burger && panel) {
    burger.addEventListener('click', function(){
      burger.classList.toggle('open');
      panel.classList.toggle('open');
    });
    panel.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', closeMobile);
    });
  }

  function countUp(el){
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target) || el.dataset.counted) return;
    el.dataset.counted = '1';
    if (reduceMotion) { el.textContent = target.toFixed(1).replace('.', ','); return; }
    var start = null, duration = 1200;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(1).replace('.', ',');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) {
        en.target.classList.add('is-visible');
        var counters = en.target.querySelectorAll('[data-count-to]');
        counters.forEach(countUp);
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  window.addEventListener('load', function(){
    document.querySelectorAll('.hero .reveal').forEach(function(el){ el.classList.add('is-visible'); });
  });

  // Same-page anchor links (e.g. nav "Leistungen" on the homepage scrolling to #leistungen)
  document.addEventListener('click', function(e){
    var el = e.target.closest('a[href^="#"]');
    if (!el) return;
    var id = el.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    closeMobile();
  });

  var reviewsTrack = document.getElementById('reviewsTrack');
  var reviewsPrev = document.getElementById('reviewsPrev');
  var reviewsNext = document.getElementById('reviewsNext');
  var reviewsProgress = document.getElementById('reviewsProgress');
  var reviewsCarousel = reviewsTrack ? reviewsTrack.closest('.reviews-carousel') : null;
  if (reviewsTrack && reviewsPrev && reviewsNext) {
    var totalReviews = reviewsTrack.children.length;

    function reviewsScrollBy(dir){
      var amount = reviewsTrack.clientWidth * 0.9 * dir;
      reviewsTrack.scrollBy({ left: amount, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    reviewsPrev.addEventListener('click', function(){ reviewsScrollBy(-1); });
    reviewsNext.addEventListener('click', function(){ reviewsScrollBy(1); });

    function updateReviewsNav(){
      var maxScroll = reviewsTrack.scrollWidth - reviewsTrack.clientWidth;
      reviewsPrev.disabled = reviewsTrack.scrollLeft <= 4;
      reviewsNext.disabled = reviewsTrack.scrollLeft >= maxScroll - 4;

      var cardWidth = reviewsTrack.firstElementChild ? reviewsTrack.firstElementChild.offsetWidth + 16 : 1;
      var visibleCount = Math.max(1, Math.round(reviewsTrack.clientWidth / cardWidth));
      var currentIndex = Math.min(totalReviews, Math.round(reviewsTrack.scrollLeft / cardWidth) + 1);
      var lastVisible = Math.min(totalReviews, currentIndex + visibleCount - 1);
      if (reviewsProgress) reviewsProgress.textContent = currentIndex + '–' + lastVisible + ' / ' + totalReviews;
    }
    reviewsTrack.addEventListener('scroll', updateReviewsNav, { passive:true });
    window.addEventListener('resize', updateReviewsNav);
    updateReviewsNav();

    var reviewsAutoTimer = null;
    function reviewsAutoTick(){
      var maxScroll = reviewsTrack.scrollWidth - reviewsTrack.clientWidth;
      if (reviewsTrack.scrollLeft >= maxScroll - 4) {
        reviewsTrack.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        reviewsScrollBy(1);
      }
    }
    function startReviewsAuto(){
      stopReviewsAuto();
      reviewsAutoTimer = setInterval(reviewsAutoTick, 4200);
    }
    function stopReviewsAuto(){
      if (reviewsAutoTimer) { clearInterval(reviewsAutoTimer); reviewsAutoTimer = null; }
    }
    if (reviewsCarousel) {
      reviewsCarousel.addEventListener('mouseenter', stopReviewsAuto);
      reviewsCarousel.addEventListener('mouseleave', startReviewsAuto);
      reviewsCarousel.addEventListener('touchstart', stopReviewsAuto, { passive:true });
    }
    startReviewsAuto();
  }
})();
